import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    items: [],
  },
  reducers: {
    addToCart: (state, action) => {
      const product = action.payload;
      const existing = state.items.find((item) => item.id === product.id);
      if (existing) {
        existing.quantity += product.quantity || 1;
      } else {
        state.items.push({ ...product });
      }
    },
    removeFromCart: (state, action) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
    clearCart: (state) => {
      state.items = [];
    },
    updateCartPrices: (state, action) => {
      const updatedItems = action.payload;
      state.items = state.items.map(item => {
        const updatedItem = updatedItems.find(updated => 
          updated.id === item.id && updated.is_combo === item.is_combo
        );
        if (updatedItem) {
          return {
            ...item,
            ...updatedItem
          };
        }
        return item;
      });
    }
  },
});

export const { addToCart, removeFromCart, clearCart,updateCartPrices } = cartSlice.actions;
export default cartSlice.reducer;
